import FeatureGrid from "@/components/base/FeatureGrid";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { aboutApproach } from "@/mocks/about";

export default function AboutApproach() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Yaklaşımımız"
            title="Bekleme yok, sürpriz yok; net süreç"
            description="Her hizmetimiz tek bir hedef için tasarlandı: Diş hekiminizin tedavi planlamasını hızlandırmak ve hastanın bekleme deneyimini sıfıra indirmek."
          />
        </Reveal>

        <div className="mt-14">
          <FeatureGrid items={aboutApproach} columns={2} />
        </div>
      </div>
    </section>
  );
}